import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredVolatilityMedium = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 13 14"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M6.35595 5.33811L7.30312 4.29948L8.68332 5.31893C8.73134 4.9525 8.71168 4.57916 8.62495 4.22098C8.52539 3.7524 8.30205 3.32486 7.98204 2.98988C7.66204 2.6549 7.25904 2.42674 6.82146 2.33307C6.87714 2.0476 6.99326 1.77974 7.16092 1.55047C7.43787 1.21259 7.83405 1.0161 8.25237 1.00897L8.18034 0C7.84688 0.0124894 7.51963 0.0996924 7.21909 0.25581C6.91875 0.411928 6.65173 0.633838 6.43502 0.907045C6.13675 1.31518 5.94177 1.79982 5.86891 2.31344C3.8694 2.63861 3.61108 4.90879 3.61108 4.90879L5.22103 4.08159L6.35595 5.33811Z"
      fill="url(#paint0_linear_7560_29769)"
    />
    <path
      d="M11.7486 12.2472L11.7033 12.2283C10.9639 11.9283 10.2947 11.4568 9.7431 10.8471C9.26371 10.2944 8.905 9.63313 8.69367 8.91142C8.47716 8.28539 8.34262 7.6297 8.29398 6.96352C8.26976 6.5284 8.27555 6.09193 8.31136 5.65748L7.36191 4.95651L6.35347 6.06205L5.11941 4.69513L3.92757 5.30555C3.82035 6.04867 3.81642 6.80472 3.91598 7.54918C4.09212 8.88444 4.60256 10.143 5.39263 11.1894C6.1678 12.1779 7.15948 12.9426 8.27804 13.4139C8.54091 13.533 8.81103 13.6322 9.08653 13.7114C9.35334 13.7997 9.62553 13.8673 9.90124 13.9139C10.4409 14.0073 10.9896 14.0247 11.5333 13.9661C11.7817 13.9389 12.0055 13.7926 12.1423 13.5675C12.2791 13.3425 12.3145 13.063 12.2383 12.8068C12.1624 12.5505 11.9829 12.3451 11.7503 12.2474L11.7486 12.2472Z"
      fill="url(#paint1_linear_7560_29769)"
    />
    <path
      d="M2.28676 4.72033C2.28676 4.72033 2.44339 3.28769 3.44157 2.44915C3.32549 2.39942 3.20564 2.36017 3.083 2.33274C3.13647 2.04728 3.24798 1.77944 3.40897 1.55018C3.67492 1.21231 4.05535 1.01583 4.45705 1.0087L4.38768 0C4.06747 0.0124888 3.75323 0.0996877 3.46463 0.255798C3.17622 0.411909 2.91982 0.633808 2.71171 0.907002C2.4253 1.31512 2.23806 1.79973 2.1681 2.31333C0.248055 2.63849 0 4.90856 0 4.90856L1.54597 4.0814"
      fill="url(#paint2_linear_7560_29769)"
    />
    <path
      d="M4.14617 11.5477C3.32171 10.4103 2.78883 9.04237 2.60477 7.59099C2.53521 7.04928 2.51434 6.50178 2.54157 5.95673L2.3118 5.69224L1.44817 4.69559L0.303701 5.30598C0.200742 6.04906 0.196965 6.80508 0.29257 7.54951C0.461717 8.8847 0.951865 10.1432 1.71054 11.1896C2.45491 12.178 3.40718 12.9427 4.48129 13.4139C4.73372 13.533 4.9931 13.6322 5.25745 13.7114C5.51366 13.7997 5.77503 13.8673 6.03978 13.9139C6.43095 13.9844 6.82688 14.0116 7.22222 13.9955C7.20076 13.9857 7.17929 13.9759 7.15782 13.9659C5.99029 13.4536 4.95514 12.6222 4.14617 11.5477Z"
      fill="url(#paint3_linear_7560_29769)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7560_29769"
        x1={6.49997}
        y1={0}
        x2={6.49997}
        y2={14}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF347" />
        <stop offset={1} stopColor="#ED023B" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7560_29769"
        x1={6.49997}
        y1={0}
        x2={6.49997}
        y2={14}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF347" />
        <stop offset={1} stopColor="#ED023B" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_7560_29769"
        x1={2.40741}
        y1={0}
        x2={2.40741}
        y2={14}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF347" />
        <stop offset={1} stopColor="#ED023B" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_7560_29769"
        x1={2.40741}
        y1={0}
        x2={2.40741}
        y2={14}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF347" />
        <stop offset={1} stopColor="#ED023B" />
      </linearGradient>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgColouredVolatilityMedium)
const IconSvgColouredVolatilityMedium = createIcon(
  ForwardRef,
  'SvgColouredVolatilityMedium',
)
export default IconSvgColouredVolatilityMedium
